// extracted by mini-css-extract-plugin
module.exports = {"shareScreenBtn":"shareScreenBtn___3hIAS","disable":"disable___2gb3l","on":"on___2Nr02","btn-wrap":"btn-wrap___1_m-s","icon":"icon___2jJw-"};